<template>
  <span v-if="listActaDocs && listActaDocs.length > 0">
    <p>
      <b>{{ title }}:</b>
      <span v-for="documento in listActaDocs" v-bind:key="documento.filename">
        <Button
          @click.stop="
            getDocumentoMinio(
              documento.tipo,
              documento.clave,
              documento.filename
            )
          "
          v-tooltip.bottom="documento.filename"
          class="
            centerButton
            p-button
            p-component
            p-button-transparent
            p-button-icon-only
            p-button-outlined
            status-envio
          "
          icon="pi pi-file-pdf"
          iconPos="left"
        />
      </span>
    </p>
    <p v-if="estadoEnvio && estadoEnvio.envioEncontradoBBDD">
      <b>{{ $t("detalleReclamacion.localizador") }}:</b>
      {{ estadoEnvio.localizadorProveedor }}
    </p>
  </span>
</template>


<script>
import DownloadsMixin from "@/utils/downloads";

export default {
  mixins: [DownloadsMixin],
  name: "ActaProvisionalDefinitiva",
  props: {
    listActaDocs: Array,
    title: String,
    estadoEnvio: Object,
  },
};
</script>
<style lang="scss" scoped>
.p-button {
  margin-left: 5px;
}
</style>